import { ICohortVessel } from '../../../../common/cohort/cohortTypes';
import CohortDefinition from '../../../../common/cohort/components/characteristic/CohortDefinition';
import { IVesselKeyMetricsDateBased } from '../../../../green/greenTypes';
import { TKeyMetrics, TSummaryKeyMetrics } from '../../../kpiTypes';
import KeyMetrics from '../../overview/KeyMetrics';

interface IKeyMetricsProps {
	vessel: ICohortVessel;
	minSize: number;
	maxSize: number;
	cohortVessels: ICohortVessel[];
	vesselKeyMetrics: TKeyMetrics;
	cohortKeyMetrics: TSummaryKeyMetrics;
	vesselKeyMetricsDateBased: IVesselKeyMetricsDateBased[] | null;
	vesselCohortKeyMetricsDateBased: IVesselKeyMetricsDateBased[] | null;
	minAge: number;
	maxAge: number;
}

const CohortKeyMetrics: React.FC<IKeyMetricsProps> = ({ ...props }) => {

	const cohortVesselInfo = props.cohortVessels.length === 1 ? props.cohortVessels[0] : props.vessel;

	return (
		<div className="flex flex-row gap-4 w-full">
			<div className="flex flex-col gap-2 w-full">
				<div className="flex-none">
					<CohortDefinition
						title={props.vessel.name}
						shipsNumber={props.cohortVessels.length}
						size={props.vessel.size}
						sizeUnit={props.vessel.sizeUnit}
						age={props.vessel.age}
						isCohort={false}
						
					/>
				</div>
				<div className="flex-auto  border border-msi-darkgrey-color-300 rounded p-2">
					<KeyMetrics
						keyMetricsData={props.vesselKeyMetrics ? props.vesselKeyMetrics.data : null}
						keyMetricsDateBased={
							props.vesselKeyMetricsDateBased && props.vesselKeyMetricsDateBased.length > 0
								? props.vesselKeyMetricsDateBased[0]
								: null
						}
					/>
				</div>
			</div>
			<div className="flex flex-col gap-2 w-full">
				<div className="flex-none">
					<CohortDefinition
						title="Cohort (Average By Vessel)"
						minSize={props.minSize}
						maxSize={props.maxSize}
						shipsNumber={props.cohortVessels.length}
						size={cohortVesselInfo.size}
						sizeUnit={cohortVesselInfo.sizeUnit}
						age={cohortVesselInfo.age}
						minAge={props.minAge}
						maxAge={props.maxAge}
						isCohort={true}
					/>
				</div>
				<div className="flex-auto border border-msi-darkgrey-color-300 rounded p-2">
					<KeyMetrics
						keyMetricsData={
							props.cohortKeyMetrics.sectorListKeyMetrics ? props.cohortKeyMetrics.sectorListKeyMetrics[0].data : null
						}
						keyMetricsDateBased={
							(props.vesselCohortKeyMetricsDateBased &&
								props.vesselCohortKeyMetricsDateBased.length > 0 &&
								props.vesselCohortKeyMetricsDateBased[0]) ||
							null
						}
					/>
				</div>
			</div>
		</div>
	);
};

export default CohortKeyMetrics;
